import { render, staticRenderFns } from "./Ciao.vue?vue&type=template&id=d022daa8&scoped=true&"
import script from "./Ciao.vue?vue&type=script&lang=js&"
export * from "./Ciao.vue?vue&type=script&lang=js&"
import style0 from "./Ciao.vue?vue&type=style&index=0&id=d022daa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d022daa8",
  null
  
)

export default component.exports